

import { useOutletContext } from "react-router-dom";
import { CustomTextField } from "../../../../../components/CustomTextField";
import CustomModal from "../../../../../components/Modal/CustomModal";
import AddEditFineTypeApp from "../Functionality/AddEditFineTypeApp";
import { MODAL_NAMES, toggleFinesModal } from "../Model/Model";

/**
 * @Author      Jhovanny Fragoso Márquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 * 
 * @description
    * React component that renders a ** modal dialog ** for creating or editing Fine Types.
 * It integrates with the`AddEditFineTypeApp` hook to manage form logic(validation, submission, clearing).
 *
 * Depending on the modal mode(`isCreateModal` or`isEditModal`), it adjusts the modal title and behavior.
 *
 * @component
    * @param { Object } props - Component properties.
 * @param { boolean } props.show - Determines if the modal should be visible.
 * @param { Function } props.onHide - Function to close the modal.
 * @param { Function } props.setModified - Function to notify the parent component that data has changed.
 *
 * @returns { JSX.Element } The rendered modal component for Fine Type creation or editing.
 */


const AddEditFineType = (props) => {
    const { show, setModified } = props;
    const { fineType } = useOutletContext();


    const {
        t,
        disabled,
        emptyFields,
        handleChange,
        handleSubmit,
        handleClearFields,
    } = AddEditFineTypeApp({ show, setModified });

    const { isEditModal, isCreateModal } = fineType;
    const { setFineType } = useOutletContext();
    
    return (
        <CustomModal
            {...props}
            title={t(isEditModal ? 'update_fine_type' : 'create_fine_type')}
            size='md'
            onConfirm={handleSubmit}
            onClear={handleClearFields}
            disabled={disabled}
            show={isCreateModal || isEditModal}
            onHide={() => toggleFinesModal(isEditModal ? MODAL_NAMES.EDIT : MODAL_NAMES.CREATE, setFineType, false)}
        >
            <div className='row'>
                <div className='col-12'>
                    <CustomTextField
                        id='txt_aeft_fine_type'
                        name='name'
                        length={32}
                        value={fineType?.name}
                        trans='fine_type'
                        emptyFields={emptyFields}
                        required={true}
                        onChange={handleChange}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default AddEditFineType;
